import React, { useEffect } from 'react';
import { Link, Route, useNavigate ,useLocation,  } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
//import msalInstance from '../../configs/msalConfig';

import UsersService from '../../services/usersService';


const Login = ({ instance , url }) => {
    //const { instance } = useMsal();
  
    const account = useAccount();
    const fromUrl = url?.pathname + url?.search || null;
    useEffect(() => {
    const login = async () => {
      try {
        await instance.handleRedirectPromise();
        if (!instance.getActiveAccount()) {

          await instance.loginRedirect();
        }
      } catch (error) {
        console.log(error);
      }
    };

    login();
  }, [instance]);

  // const getUserDetails = async () => {
  //   localStorage.removeItem("userImpersonateData");

  //   if (account) {
  //     const userDetails = await instance.acquireTokenSilent({
  //       scopes: ['user.read'],
  //       account: account,
  //     });
  //     console.log("getUserDetails",userDetails);
  //     console.log("getUserDetails User Name",userDetails.account.username);
  //     // Redirect based on user's role here
  //     const userName = userDetails.account != null ? userDetails.account.username: "";
  //     let url = "";
  //      var objLoginUser = await checkUserLogin(userName);  
  
  //     if (objLoginUser !== null && objLoginUser.length > 0) {  
  //       const userData = {
  //         userName: objLoginUser[0].UserName,
  //         userRole: objLoginUser[0].RoleName,
  //         userEmail: objLoginUser[0].Email,
  //         userShortName: objLoginUser[0].FirstName.substring(0, 1) + objLoginUser[0].LastName.substring(0, 1),
  //         userId: objLoginUser[0].UserId,
  //       };
  //       localStorage.removeItem("reduxState");
  
  //       localStorage.setItem("userData", JSON.stringify(userData));
  
  //       if (objLoginUser[0].RoleName === "SuperAdmin" || objLoginUser[0].RoleName === "Admin") {
  //         url = "/dashboard";
  //         window.location.href = url;
  //       }
  //       else if (objLoginUser[0].RoleName === "DataProvider") {
  //         url = "/serviceprovider-dashboard";
  //         window.location.href = url;
  //       }
  //       else if (objLoginUser[0].RoleName === "Reviewer") {
  //         url = "/reviewer-dashboard";
  //         window.location.href = url;
  //       }
  //     }
  //     // else{
  //     //   url = "/unauthorizedaccess";
  //     //   window.location.href = url;
  //     // }
  //   }
  // };

  // useEffect(() => {
  //   getUserDetails();
  // }, [account]);

  ///////

  useEffect(() => {
    const getUserDetails = async () => {
      if (account) {
        try {
          const userDetails = await instance.acquireTokenSilent({
            scopes: ['user.read'],
            account: account,
          });
          const userName = userDetails.account.username || "";
          const user = await checkUserLogin(userName);
          if(user.length){
            handleUserRedirection(user);
          }else{
            window.location.href = '/unauthorizedaccess'
          }
        } catch (error) {
          if (error.errorCode === 'login_required') {
            console.log("Silent sign-in failed, clearing cache and retrying:", error);
            //await instance.getTokenCache().clear();
            await instance.loginRedirect();
          } else {
            console.log("Error getting user details:", error);
          }
        }
      }
    };

    getUserDetails();
  }, [account, instance]);

  const checkAuthorisedUser = (url , roleName)=>{
    const parts = url.split('?');
    const path = parts[0];
    const pathParts = path.split('/').filter(part => part !== '')[0];
    switch (pathParts) {
      case 'viewuploadedfiles':
        return (roleName === 'SuperAdmin' || roleName === 'Admin') ? url : '/unauthorizedaccess';
      case 'reviewer-dashboard':
        return (roleName === 'Reviewer') ? url : '/unauthorizedaccess';
      case 'serviceprovider-dashboard':
        return (roleName === 'DataProvider') ? url : '/unauthorizedaccess';
      default:
        return '/unauthorizedaccess';
    }

  }

  const handleUserRedirection = (user) => {
    if (user && user.length > 0) {
      const userData = {
        userName: user[0].UserName,
        userRole: user[0].RoleName,
        userEmail: user[0].Email,
        userShortName: user[0].FirstName.substring(0, 1) + user[0].LastName.substring(0, 1),
        userId: user[0].UserId,
      };
      localStorage.removeItem("reduxState");
      localStorage.setItem("userData", JSON.stringify(userData));

      let url = "/";
      const roleName = user[0].RoleName;
      const authorizedUrl = {
        SuperAdmin: '/dashboard',
        Admin: '/dashboard',
        DataProvider: '/serviceprovider-dashboard',
        Reviewer: '/reviewer-dashboard',
      };
      // switch (user[0].RoleName) {
      //   case "SuperAdmin":
      //   case "Admin":
      //     url = fromUrl ? checkAuthorisedUser(fromUrl , user[0].RoleName) :"/dashboard" ;
      //     break;
      //   case "DataProvider":
      //     url = fromUrl ? checkAuthorisedUser(fromUrl , user[0].RoleName) : "/serviceprovider-dashboard";
      //     break;
      //   case "Reviewer":
      //     url = fromUrl ? checkAuthorisedUser(fromUrl , user[0].RoleName) : "/reviewer-dashboard";
      //     break;
      //   default:
      //     url = "/unauthorizedaccess";
      // }
      url = fromUrl ? checkAuthorisedUser(fromUrl, roleName) : authorizedUrl[roleName];

      window.location.href =  url || '/unauthorizedaccess';

    } else {
      console.log("No user found or unauthorized access");
    }
  };
//

  const checkUserLogin = async(userName) =>{
    var objUser;
    await UsersService.getUserDetailByEmail(userName).then((response) => {
      if (response.status !== 200) {
        throw new Error("Network response was not ok");
      }
      objUser = response.data.data;
    })
      .catch((error) => {
        objUser = null;
        console.error("Error fetching data from the API:", error);
      });

    return objUser;
  };
  
  
    return (
      <div>
      </div>
    );
  };
  
  export default Login;